export enum RouteNames {
    LOGIN = '/login',
    REGISTRATION = '/registration',
    FORGET_PASSWORD = '/forget_password',
    MAIN = '/',
    NOT_FOUND = '*',
    ARCHIVE = '/archive',
    CITY = '/city',
    COUNTRY = '/country',
    RESET_PASSWORD = '/reset-password',
}
